// extracted by mini-css-extract-plugin
export default {"cursor-grab":"dnd_cursor-grab__cLVW-"};